import { TYPES } from "@actions/user-actions";
import { TYPES as AUTH_TYPES } from "@actions/auth-actions";
import { TYPES as USER_HEADERS_TYPES } from "@actions/user-headers-actions";
import INITIAL_STATE from "./initial-state";

const userReducer = (state = INITIAL_STATE.user, action) => {
  switch (action.type) {
    case AUTH_TYPES.SIGN_IN: {
      return {
        ...state,
        currentUser: action.user,
      };
    }

    case AUTH_TYPES.SIGN_OUT: {
      return {
        ...state,
        currentUser: null,
      };
    }

    case TYPES.UPDATE_SUBSCRIPTION: {
      const { subscription } = action;
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          subscription,
        },
      };
    }

    case TYPES.SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          state: "subscriber",
        },
      };
    }

    case TYPES.UPDATE_PROFILE_INFOS: {
      const { profileInfos } = action;

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          ...profileInfos,
        },
      };
    }

    case TYPES.SET_DEFAULT_PAYMENT_METHOD: {
      // eslint-disable-next-line camelcase
      const { default_payment_method } = action;
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          default_payment_method,
        },
      };
    }

    case TYPES.DISABLE_FEEDBACK_AVAILABLE: {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          feedback_available: false,
        },
      };
    }

    case TYPES.SET_PRODUCTS_LIKED: {
      const { productsLiked } = action;
      return {
        ...state,
        productsLiked,
      };
    }

    case TYPES.SET_PRODUCTS_RENTED: {
      const { productsRented } = action;
      return {
        ...state,
        productsRented,
      };
    }

    case USER_HEADERS_TYPES.SET_USER_HEADER_LAST_VERSION: {
      const { userHeaderLastVersion } = action;
      return {
        ...state,
        userHeaderLastVersion,
      };
    }

    case USER_HEADERS_TYPES.SET_CLOSET_HEADER_LAST_VERSION: {
      const { closetHeaderLastVersion } = action;
      return {
        ...state,
        closetHeaderLastVersion,
      };
    }

    default:
      return state;
  }
};

export default userReducer;
